export function createScrollToHandler(element: Element) {
    element.addEventListener('click', (e: Event) => {
        const hrefAttribute = element.getAttribute('href');

        if (!/^(\/)?#/.test(hrefAttribute!)) {
            return;
        }

        e.preventDefault();

        const attributeId = hrefAttribute?.replace('#', '');
        const targetBlock = document.getElementById(attributeId!);

        if (!targetBlock) {
            console.warn('Cannot find target element');
            return;
        }

        const headerHeight =
            document.querySelector('.g-header')?.getBoundingClientRect()?.height || 0;

        const rect = targetBlock.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        window.scroll({
            top: rect.top + scrollTop - headerHeight - 20,
            left: 0,
            behavior: 'smooth',
        });
    });
}
